import { Link, useLocation } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import classes from "./Breadcrumbs.module.css";
import { Breadcrumb } from "antd";

enum Names {
  "rrzj" = "RRZJ",
  "Komunikacni-cinnosti-strategie" = "Komunikační činnost a strategie",
  "O-tomto-dokumentu" = "O tomto dokumentu",
  "Referencni-urovne-desckriptory-stupnice" = "Referenční úrovně, deskriptory a stupnice pro znakové jazyky",
  "Uzivani-jazyka-komunikacni-cinnosti-strategie" = "Užívání jazyka a komunikační činnosti a strategie",
  "Komunikacni-jazykove-kompetence" = "Komunikační jazykové kompetence",
  "Seznam-zkratek" = "Seznam zkratek",
  "Reference" = "Reference",
  "glosar" = "Glosář",
  "proverejnost" = "Pro veřejnost",
  "download" = "Ke stažení",
  "vyhledavani" = "Vyhledávání",
  "popisy" = "Popisy",
  "seznam-obrazku" = "Seznam obrázků",

  /* public articles */
  "Co-vime-o-neslysicich-lidech-a-jejich-jazyce" = "Co víme o neslyšících lidech a jejich jazyce?",
  "Jak-neslysici-lide-komunikuji-cestina-a-cesky-znakovy-jazyk" = "Jak neslyšící lidé komunikují: čeština a český znakový jazyk",
  "Dva-jazyky-ve-vzdelavani-neslysicich-zaku" = "Dva jazyky ve vzdělávání neslyšících žáků",
  "Proc-potrebujeme-Referencni-ramec-pro-znakove-jazyky-a-Popisy-referencnich-urovni-A1-B2-pro-cesky-znakovy-jazyk-prvni-cast" = "Proč potřebujeme Referenční rámec pro znakové jazyky a Popisy referenčních úrovní A1–B2 pro český znakový jazyk – první část",
  "Proc-potrebujeme-Referencni-ramec-pro-znakove-jazyky-a-Popisy-referencnich-urovni-A1-B2-pro-cesky-znakovy-jazyk-druha-cast" = "Proč potřebujeme Referenční rámec pro znakové jazyky a Popisy referenčních úrovní A1–B2 pro český znakový jazyk – druhá část",
  "Dulezite-dokumenty-ze-kterych-vytvareni-Referencniho-ramce-pro-znakove-jazyky-a-Popisu-referencnich-urovni-A1-B2-pro-cesky-znakovy-jazyk-vychazelo" = "Důležité dokumenty, ze kterých vytváření Referenčního rámce pro znakové jazyky a Popisů referenčních úrovní A1–B2 pro český znakový jazyk vycházelo",
  "Proc-na-me-mavas-aneb-co-vsechno-by-melo-byt-soucasti-kurzu-ceskeho-znakoveho-jazyka" = "Proč na mě máváš? aneb co všechno by mělo být součástí kurzů českého znakového jazyka",
  "Resersiste-aneb-Detektivni-kancelar-realizacniho-tymu" = "Rešeršisté aneb Detektivní kancelář realizačního týmu…",
  "Jak-pracoval-lingvisticky-tym-aneb-Dalsi-odborne-texty-by-mely-vznikat-primo-v-ceskem-znakovem-jazyce" = "Jak pracoval lingvistický tým aneb Další odborné texty by měly vznikat přímo v českém znakovém jazyce ",
  "Tlumocnicko-prekladatelsky-tym-aneb-Jak-do-ceskeho-znakoveho-jazyka-prelozit-poznamku-pod-carou-a-text-ktery-jeste-neexistuje" = "Tlumočnicko-překladatelský tým aneb Jak do českého znakového jazyka přeložit poznámku pod čarou a text, který ještě neexistuje…",
  "Zpetnovazebni-tym-aneb-Jak-zjistit-co-vsechno-musime-napsat-jinak" = "Zpětnovazební tým aneb Jak zjistit, co všechno musíme napsat jinak ",
  "Korektorsko-editorsky-tym-aneb-Vizaziste-styliste-a-plasticti-chirurgove-textu" = "Korektorsko-editorský tým aneb Vizážisté, stylisté a plastičtí chirurgové textů",
  "Webovy-tym-aneb-Jak-udelat-e-knihu-ve-znakovem-jazyce" = "Webový tým aneb Jak udělat e-knihu ve znakovém jazyce?",
  "Rozhovor-s-Martinem-Kafkou-aneb-Kdyz-by-se-i-mravenci-mohli-ucit-synchronizaci-a-pracovnimu-nasazeni" = "Rozhovor s Martinem Kafkou aneb Když by se i mravenci mohli učit synchronizaci a pracovnímu nasazení...",
  "A-co-dal-aneb-Jak-nejlepe-vyuzit-vystupy-KA-5-Referencni-ramec-pro-znakove-jazyky-a-Popisy-referencnich-urovni-A1-B2-pro-cesky-znakovy-jazyk" = "A co dál aneb Jak nejlépe využít výstupy KA 5 – Referenční rámec pro znakové jazyky a Popisy referenčních úrovní A1–B2 pro český znakový jazyk",
  "Rozhovor-s-Petrem-Vysuckem-a-Radkou-Novakovou" = "Rozhovor s Petrem Vysučkem a Radkou Novákovou",

  /* popisy */
  "O-tomto-dokumentu-a-jeho-vztahu-k-dalsim-materialum" = "O tomto dokumentu a jeho vztahu k dalším materiálům",
  "Cesky-znakovy-jazyk-zakladni-informace-pro-lektory-a-studenty" = "Český znakový jazyk: základní informace pro lektory (a studenty)",
  "Minimum-z-gramatiky-a-znakove-zasoby-ceskeho-znakoveho-jazyka" = "Minimum z gramatiky a znakové zásoby českého znakového jazyka",
  "Sociokulturni-znalosti-a-dovednosti" = "Sociokulturní znalosti a dovednosti",
  "Tematicke-okruhy" = "Tematické okruhy",
  "Vokabular-priloha" = "Vokabulář",
  "Prehled-tvaru-ruky-ceskeho-znakoveho-jazyka" = "Přehled tvarů ruky českého znakonévho jazyka",
  "Seznam-zkratek-uziti-symbolu-a-poznamek-k-zapisu-znaku" = "Seznam zkratek, užití symbolů a poznámek k zápisu znaků",
  "Seznam-obrazku-a-tabulek" = "Seznam obrázků a tabulek",
  "Seznam-pouzite-literatury" = "Seznam použité literatury",
  "Seznam-doporucene-literatury-dle-temat" = "Seznam doporučené literatury (dle témat)",
  "enis" = "Framework of Reference for Sign Languages: Summary",
  "vokabular" = "Vokabulář",
}

const Breadcrumbs = () => {
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const extraBreadcrumbItems = pathSnippets.map((name, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    return (
      <Breadcrumb.Item key={url} className={classes.item}>
        <Link to={url}>{Names[name as keyof typeof Names]}</Link>
      </Breadcrumb.Item>
    );
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="home">
      <Link style={{ color: "black" }} to="/">
        <HomeOutlined />
      </Link>
    </Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <div className={classes.wrapper}>
      <Breadcrumb separator="     >  ">{breadcrumbItems}</Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
